import React from 'react';
import styles from './remove-font-overlay.scss';

class RemoveFontOverlay extends React.Component {
  constructor() {
    super();

    this.onConfirm = this.onConfirm.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  onConfirm() {
    this.props.modalActionsSubject.onNext({
      type: 'confirmFontRemoval',
      data: {family: this.props.fontFamily}
    });
  }

  onCancel() {
    this.props.modalActionsSubject.onNext({type: 'cancelRemoveFont'});
  }

  render() {
    const fontName = this.props.fontFamily || 'the chosen font';

    return (
      <div className={`${styles.overlay} modal-sheet asset-delete`}>
        <div className={styles.contentContainer}>
          <div className='warning-header-icon svg-ico-warning4' />

          <div className={styles.warningText}>
            <div className={styles.warningTitle}>
              {`You are about to remove ${fontName}, which is currently in use.`}
            </div>
            <div className={styles.warningMessage}>
              Any text using this font will switch to the default font.
            </div>
          </div>

          <div className={styles.buttonsContainer}>
            <div className={styles.button} onClick={this.onCancel}>
              Cancel
            </div>
            <div
              className={`${styles.button} ${styles.deleteButton}`}
              onClick={this.onConfirm}
            >
              Remove Font
            </div>
          </div>

        </div>
      </div>
    );
  }
}

RemoveFontOverlay.propTypes = {
  fontFamily: React.PropTypes.string,
  modalActionsSubject: React.PropTypes.object
};

export default RemoveFontOverlay;



// WEBPACK FOOTER //
// ./src/fonts/font-picker/remove-font-overlay.jsx